const STAGGER_TIME = 16; // ~1 frame. 0ms also works, but this is safer.
let chain = Promise.resolve();

export function staggerAfsRequests(fn: () => void) {
  // Staggering prevents page from hanging upon first filter interaction
  // Single chain is for all AFS placements on the page
  chain = chain
    .then(
      () =>
        new Promise<void>((res) => {
          setTimeout(res, STAGGER_TIME);
        })
    )
    .then(fn)
    .catch((err: unknown) => {
      console.error('AFS request failed', err);
    }); // prevent chain break
}
